import React, { useState } from "react";
import { Link } from "react-router-dom";
const RenderRating = ({
  rateLogin,
  ratings,
  manageVotes,
  handleRate,
  handleShowModal,
  loggedIn,
}) => {
  const [pop, setPop] = useState(false);
  const handleGetUserCurrentStatus = () => {
    if (!loggedIn) {
      setPop(!pop);
    }
  };
  return (
    <div className="star-rating-wrapper">
      <div className="star-rating" onClick={handleShowModal}>
        {[...Array(5)].map((_, index) => (
          <span
            onClick={handleGetUserCurrentStatus}
            key={index}
            className={index < ratings ? "full-star" : "normal-star"}
          ></span>
        ))}
        {manageVotes ? (
          <span className="votes"> ({`${ratings} votes`})</span>
        ) : null}
      </div>

      <div className="rating-nums">ratings</div>
      {rateLogin && pop ? (
        <div className="rate-course rate-course-login">
          <div className="arrow-up"></div>
          <div className="close-button-login" onClick={() => setPop(false)}>
            <i className="icon check"></i>
          </div>
          <div className="star-text">Please login</div>

          <div className="button-wrapper">
            <div className="btn btn-back" onClick={() => setPop(false)}>
              <a>Later</a>
            </div>
            <div className="btn rate" onClick={handleRate}>
              <Link to="/login">Login</Link>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default RenderRating;
